import { FloorPlan } from "../objects/FloorPlan";
import { Action } from "./Action";
import { SaveAction } from "./SaveAction";

export class DeleteWallNodeAction implements Action {

    private id:number;
    private receiver:FloorPlan;
    constructor(id:number) {
        this.id = id;
        this.receiver = FloorPlan.Instance;
    }

    public execute(): void {
        this.receiver.actions.push(this);
        this.receiver.removeWallNode(this.id);
        const node:any = new SaveAction();
        node.execute();
    }
}

